import { useContext } from "react";
import useUserState from "../../hooks/useUserState";
import { SubscriptionData } from "../../lib/mappers/subscriptionData";
import StripeWrapper from "../../StripeWrapper";
import { PaymentInfo } from "../../lib/types";
import PaymentInfoContext from "../../context/PaymentInfoContext";
import FreeTrial from "./FreeTrial";

const FreeTrialStripeWrapper = ({
  freeTrialActive = false,
  multiplan = false,
}: {
  freeTrialActive?: boolean;
  multiplan?: boolean;
}) => {
  const { subscriptionInfo } = useUserState();
  const paymentInfo = useContext<PaymentInfo>(PaymentInfoContext);

  if (subscriptionInfo === null) {
    return null;
  }

  const subscriptionData = new SubscriptionData(subscriptionInfo, paymentInfo);

  if (subscriptionData.missingPaymentInfo()) {
    return null;
  }

  return (
    <StripeWrapper clientSecret={subscriptionData.getClientSecret()}>
        <FreeTrial
          subscriptionData={subscriptionData}
          freeTrialActive={freeTrialActive}
          multiplan={multiplan}
        />
    </StripeWrapper>
  );
};

export default FreeTrialStripeWrapper;
